import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  // Список брендов
  stock_brands: [],
  // Список категорий брендов
  stock_brands_categories: [],
  // Флаг запроса брендов
  stock_brands_fetching: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
